import { ProductBundleSettings } from "../models/product.bundle";
import { DocumentData } from "@angular/fire/firestore";
import { BundleItem } from "../models/bundle-item";
import { BundleData } from "../models/bundle-data";

export class ProductBundleSettingsBuilder {
  public items: BundleItem[];
  constructor() {}

  //Editing a Product
  edit(bundle: ProductBundleSettings) {
    this.items = bundle.items;
  }

  //Loading Bundle From Firebase
  load(data: DocumentData) {
    this.items =
      data == null || data.items == null
        ? null
        : data.items.map(item => new BundleItem().load(item));
  }

  //Updating/Creating Bundle from Form
  create(form: Map<string, BundleData>) {
    this.items = [];
    form.forEach((data, key) => {
      for (var i = 0; i < data.quantity; i++) {
        this.items.push(new BundleItem(data));
      }
    });
  }

  copyBundle(items: BundleItem[]): void {
    this.items = [];
    for (var i = 0; i < items.length; i++) {
      this.items.push(new BundleItem().copy(items[i]));
    }
  }

  get totalPrice(): number {
    let count = 0;
    for (let i = 0; i < this.items.length; i++) {
      count += this.items[i].price == null ? 0 : this.items[i].price;
    }

    return count;
  }

  get totalFee(): number {
    let count = 0;
    for (let i = 0; i < this.items.length; i++) {
      count += this.items[i].price == null ? 0 : this.items[i].fee;
    }

    return count;
  }
}
